import { useEffect } from "react";
import TagManager from 'react-gtm-module'
const GTM = { id: 'GTM-WSM2RBF' }


export const useTagManager = () => {

    useEffect(() => {
        const gtm = GTM.id;
        if (!gtm) {
            return;
        }

        const tagManagerArgs = {
            gtmId: gtm.gtmId
        };

        TagManager.initialize(tagManagerArgs);

    }, []);


    return TagManager;

}
